export const toLocalDateTimeInputValue = (date = new Date(), includeSeconds = false) => {
    const offset = date.getTimezoneOffset() * 60000;
    const localTime = new Date(date.getTime() - offset);
    return localTime.toISOString().slice(0, includeSeconds ? 19 : 16);
};
